import * as UserDetailsActions from './user.action';
import * as fromUserPermissions from "./userPermission.adapter";
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const PermissionMappingState = createFeatureSelector<fromUserPermissions.PermissionMappingState>('userPermissionMapping');

export const PermissionMappingsSelector = createSelector(PermissionMappingState, fromUserPermissions.selectAllPermissionMappings);

export const PermissionMappingsEntitiesSelector = createSelector(PermissionMappingState, fromUserPermissions.selectAllPermissionMappingEntities);


export const PermissionMappingsByIdSelector = (id: number) => {
  return createSelector(PermissionMappingsSelector, (entities) => entities[id])
}
